import(/* webpackMode: "eager" */ "/app/app/(marketing)/ai-readiness/page.tsx");
